import Matter from 'matter-js'
import { Utils } from './Utils'


export class MixComp {

	/**
	 * Creates class instance
	 *
	 * @param {HTMLElement} canvas <canvas> element
	 * @param {HTMLElement} container Container element for <canvas>
	 * @param {int} pebbleWidth Width in pixels of pebble image
	 * @param {int} pebbleCount Number of pebbles to show in canvas element
	 */
	constructor( canvas, container, pebbleWidth = 12, pebbleCount = 512 ) {
		this.canvas = canvas
		this.container = container

		// don't let <canvas> get too big
		this.containerDiameter = 500

		this.pebbles = []
		this.pebbleWidth = pebbleWidth
		this.pebbleCount = pebbleCount

		this.engine = null
		this.render = null
		this.runner = null

		// to be populated when user clicks "Mix Colors"
		this.colorData = null
	}


	/**
	 * Set up MatterJS elements
	 *
	 * @return {self}
	 */
	prepWorld() {
		if ( null !== this.engine ) {
			return this
		}

		this.engine = Matter.Engine.create()

		// Earth is flat; avoid pebbles falling off the edge of world
		this.engine.gravity.x = 0
		this.engine.gravity.y = 0

		this.render = Matter.Render.create({
			canvas: this.canvas,
			element: this.container,
			engine: this.engine,
			options: {
				showSleeping: true,
				background: '#000', // placeholder; will be set to match selected colors later
				hasBounds: true,
				height: 500,
				width: 500,
				wireframes: false,
			},
		})

		this.runner = Matter.Runner.create()

		return this
	}


	/**
	 * Add color data to use for mixing pebbles
	 *
	 * @param {array} data Color data
	 * @return {void}
	 */
	setColorData( data ) {
		this.colorData = data
	}


	/**
	 * Add pebble images to canvas
	 *
	 * @return {self}
	 */
	mixColors() {
		this
			.prepWorld()
			.generatePebbles()
			.renderWorld()

		return this
	}


	/**
	 * Generate pebbles to add to world
	 *
	 * @param {bool} keep If true, keep preexisting pebbles; otherwise, clear slate
	 * @return {self}
	 */
	generatePebbles( keep = false ) {
		if ( !keep ) {
			this.clearPebbles()
		}

		this.colorData.forEach( color => {
			const { images, percentage } = color
			const count = Math.ceil( this.pebbleCount / ( 100 / percentage ) )

			for ( let i = 0; i <= count; ++i ) {
				const imgIndex = Utils.generateRandomInt( 0, images.length - 1 )
				const imgUrl = images[imgIndex]

				this.pebbles.push( this.createPebble( imgUrl ) )
				this.pebbles = Utils.shuffleArray( this.pebbles )
			}
		})

		return this
	}


	/**
	 * Create single pebble to add to world
	 *
	 * @param {string} url URL for pebble image
	 * @return {obj}
	 */
	createPebble( url ) {
		const posX = Utils.generateRandomInt( 50, this.containerDiameter - 50 )
		const posY = Utils.generateRandomInt( 50, this.containerDiameter - 50 )
		const angle = Utils.generateRandomInt( 0, 360 )

		const pebble = Matter.Bodies.circle( posX, posY, this.pebbleWidth, {
			angle,
			density: 5e-6,
			frictionAir: 0,
			restitution: 1,
			friction: 0.01,
			mass: 0,
			render: {
				sprite: {
					texture: url,
					xScale: 1.5,
					yScale: 1.5,
				},
			},
		})

		return pebble
	}


	/**
	 * Delete preexisting pebble images from canvas
	 *
	 * @return {self}
	 */
	clearPebbles() {
		Matter.Composite.allBodies( this.engine.world ).forEach( body => {
			Matter.Composite.remove( this.engine.world, body )
		})

		this.pebbles = []

		return this
	}


	/**
	 * Add pebbles to world
	 *
	 * @return {self}
	 */
	renderWorld() {
		this.container.classList.add( 'is-loading' )
		this.canvas.classList.add( 'is-loading' )

		Matter.Composite.add( this.engine.world, this.pebbles )
		Matter.Render.run( this.render )
		Matter.Runner.run( this.runner, this.engine )

		this.canvas.classList.remove( 'is-loading' )
		this.container.classList.remove( 'is-loading' )

		return this
	}


	/**
	 * Get data URL for canvas
	 *
	 * @return {string}
	 */
	getCanvasDataUrl() {
		return this.canvas.toDataURL()
	}


	/**
	 * Save current canvas state as Base64 image (for download, etc)
	 *
	 * @todo Add mix composition text
	 *
	 * @return {string} Base64 string representing image
	 */
	// getAsDownloadableImage() {
	// 	return new Promise( ( resolve, reject ) => {
	// 		const downloadable = new DownloadableCanvasImage( 700, 400 )

	// 		Promise.all(
	// 			[
	// 				downloadable.addSiteLogo( webfx.colorMixer.addonData.images.logo ),
	// 				downloadable.addPebbleImg( this.canvas.toDataURL() ),
	// 				downloadable.addColorLineItems( this.colorData ),
	// 			],
	// 		).then( () => {
	// 			resolve( downloadable.getDataUrl() )
	// 		}).catch( err => {
	// 			reject( err )
	// 		})
	// 	})
	// }

}
